import objectFitImages from 'object-fit-images';

document.addEventListener("DOMContentLoaded", function(event) {
    // object fit polyfill for IE11
    objectFitImages('img.obj-fit');
});